// CDMX-16341: a CQA_CLOSED case is terminal and read-only. Combine the case's
// closed-ness with the existing process-status editability flag so every surface
// already gated by `editable` (codes, charges, assessments, questions) blocks.
export const CQA_CLOSED_STATUS = 'CQA_CLOSED';

export const deriveClosedAwareEditable = (
  editable: boolean | undefined,
  status: string | undefined,
): boolean => !!editable && status !== CQA_CLOSED_STATUS;

export const CQA_MANAGER_ROLE = 'cqa_manager';

export const isCqaManager = (roles: unknown): boolean =>
  Array.isArray(roles) && roles.includes(CQA_MANAGER_ROLE);

export const isActiveGradingStatus = (
  status: string | undefined,
  roles?: unknown,
): boolean =>
  status === 'IN_CQA' ||
  status === 'CQA_AUDIT' ||
  (status === 'CQA_COMPLETE' && isCqaManager(roles));
